import { MouseEvent } from 'react';
import { useDispatch } from 'react-redux';
import logo from '../../assets/images/logoBck.svg';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { ModalEnum, uiActions } from '../../app/slices/ui.slice';

const IMPRESSUM_TRANS_KEY = 'footer.impressum';
const YEAR = new Date().getFullYear();

const FooterPowerBy = () => {
	const dispatch = useDispatch();
	const theme = useTheme();

	const { t } = useTranslation();

	const handleOpenImprintModal = (event: MouseEvent<HTMLElement>) => {
		event.stopPropagation();
		dispatch(uiActions.toggleModal(ModalEnum.IMPRESSIUM_MODAL));
	};

	return (
		<div
			className="footer-power-by relative w-full flex items-center justify-between"
			style={{ backgroundColor: theme.palette.primary.main, height: '40px' }}
		>
			<div className="fpb-copy ml-[3%]">
				<span>&copy;&nbsp;{YEAR}</span>
			</div>
			<div className="content absolute left-0 right-0 top-1/2 -translate-y-1/2 flex justify-center items-center">
				<div className="fpb-power">
					<span className="impressium-link">powered&nbsp;by</span>
				</div>
				<img src={logo} alt="" aria-hidden="true" className="footer-logo h-[90%] px-2" />
				<div className="fpb-power">
					<span className="impressium-link">FINcredible</span>
				</div>
			</div>
			<button type="button" className="reset-button fpb-impressium mr-[3%]" onClick={handleOpenImprintModal}>
				<span>{t(IMPRESSUM_TRANS_KEY)}</span>
			</button>
		</div>
	);
};

export default FooterPowerBy;
